"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHooks = require("@trycourier/react-hooks");

var _styled = require("../../Message/styled");

var _useHover3 = _interopRequireDefault(require("../../../hooks/use-hover"));

var _Close = _interopRequireDefault(require("./Close"));

var _MarkRead = _interopRequireWildcard(require("./MarkRead"));

var _MarkUnread = _interopRequireDefault(require("./MarkUnread"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var Styled = _styledComponents["default"].div.withConfig({
  displayName: "actions__Styled",
  componentId: "sc-1atq9qi-0"
})(function (_props) {
  return {
    display: "flex",
    height: 24,
    alignItems: "center",
    position: "absolute",
    right: 12,
    ".close": {
      marginRight: -6,
      marginLeft: 6,
      marginTop: -3
    },
    "> div": {
      display: "flex",
      alignItems: "center",
      transition: "opacity 200ms ease-in-out",
      visibility: "hidden",
      opacity: 0,
      "&:not(.visible)": {
        position: "absolute"
      },
      "&.visible": {
        opacity: 1,
        visibility: "visible"
      }
    },
    "&.hasBody": {
      top: 12
    },
    "&:not(.hasBody)": {
      top: 8
    }
  };
});

var MessageActions = function MessageActions(_ref) {
  var formattedTime = _ref.formattedTime,
      hasBody = _ref.hasBody,
      isMessageHovered = _ref.isMessageHovered,
      messageId = _ref.messageId,
      read = _ref.read,
      setAreActionsHovered = _ref.setAreActionsHovered;

  var _useHover = (0, _useHover3["default"])(),
      _useHover2 = (0, _slicedToArray2["default"])(_useHover, 2),
      actionsHoverRef = _useHover2[0],
      areActionsHovered = _useHover2[1];

  (0, _react.useEffect)(function () {
    setAreActionsHovered(areActionsHovered);
  }, [areActionsHovered]);

  var _useInbox = (0, _reactHooks.useInbox)(),
      markMessageArchived = _useInbox.markMessageArchived,
      markMessageRead = _useInbox.markMessageRead,
      markMessageUnread = _useInbox.markMessageUnread;

  var handleEvent = function handleEvent(eventName) {
    return function (event) {
      event === null || event === void 0 ? void 0 : event.preventDefault();

      if (!messageId) {
        return;
      }

      switch (eventName) {
        case "archive":
          {
            markMessageArchived(messageId);
            break;
          }

        case "read":
          {
            markMessageRead(messageId);
            break;
          }

        case "unread":
          {
            markMessageUnread(messageId);
            break;
          }
      }
    };
  };

  return /*#__PURE__*/_react["default"].createElement(Styled, {
    ref: actionsHoverRef,
    className: (0, _classnames["default"])({
      hasBody: hasBody
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      visible: isMessageHovered
    })
  }, !read && /*#__PURE__*/_react["default"].createElement(_MarkRead["default"], {
    onClick: handleEvent("read")
  }), read && /*#__PURE__*/_react["default"].createElement(_MarkUnread["default"], {
    onClick: handleEvent("unread")
  }), /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    size: "small",
    title: "archive message",
    onClick: handleEvent("archive"),
    tooltip: "Archive Message"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      visible: !isMessageHovered
    })
  }, /*#__PURE__*/_react["default"].createElement(_styled.TimeAgo, null, formattedTime), read && /*#__PURE__*/_react["default"].createElement(_MarkRead.Checkmark, {
    fill: "rgba(86, 96, 116, 0.3)",
    style: {
      marginRight: -6,
      marginLeft: -3
    }
  })));
};

var _default = MessageActions;
exports["default"] = _default;